// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PayCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PayCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PayCircleOutlined = function PayCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PayCircleOutlinedSvg
  }));
};

PayCircleOutlined.displayName = 'PayCircleOutlined';
export default React.forwardRef(PayCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PayCircleOutlined.js
// module id = 3761
// module chunks = 0